import { Avatar, Box, Stack, Typography } from '@mui/material';

import type { User } from '@/types/v2/user';

interface UserTableTileProps {
  user: User;
  size?: 'small' | 'medium' | 'large';
  showEmail?: boolean;
}

export function UserTableTile({ user, size = 'medium', showEmail = false }: UserTableTileProps): React.JSX.Element {
  return (
    <Box alignItems="center" display="flex" gap={2}>
      <Avatar
        src={user?.avatar}
        sx={{
          width: size === 'small' ? 24 : size === 'large' ? 48 : 36,
          height: size === 'small' ? 24 : size === 'large' ? 48 : 36,
        }}
      >
        {user?.first_name?.charAt(0)}
        {user?.last_name?.charAt(0)}
      </Avatar>
      <Stack>
        <Typography variant="body2">
          {user.first_name} {user.last_name}
        </Typography>
        {showEmail ? <Typography variant="body2">{user.email}</Typography> : null}
      </Stack>
    </Box>
  );
}
